import { isEmpty } from 'lodash/fp';
import { JobEventTriggerType } from 'app/lib/types/server';

export function getEventDrivenTriggers(
    triggersList: {
        _type: JobEventTriggerType;
        jobOperationType: string;
        uid: string;
        name: string;
        isDeleted: boolean;
    }[]
) {
    if (isEmpty(triggersList)) {
        return [];
    }
    return triggersList.map((trigger) =>
        trigger._type === JobEventTriggerType.JOB_RUN_COMPLETED_ENTRY
            ? {
                  _type: JobEventTriggerType.JOB_RUN_COMPLETED,
                  sourceJobDefUid: trigger.uid
              }
            : { ...trigger, _type: JobEventTriggerType.TABLE_MATERIALIZATION }
    );
}
